import { useQuery } from '@tanstack/react-query';

import { RQ_BULK_LISTING_ENABLED_KEY } from '@/modules/ReactQuery/cacheKeys';
import { getBulkListingData } from '@/modules/bulkListing/api';

export function useBulkListingEnabled(userId?: number) {
  return useQuery({
    queryFn: async () => {
      const result = await getBulkListingData();
      return result?.data.hasAccess ?? false;
    },
    queryKey: [RQ_BULK_LISTING_ENABLED_KEY, userId],
    enabled: Boolean(userId),
  });
}
